<template>
  <div class="pt-3">
    <div class="text-lg font-medium">{{ title }}</div>
    <div class="text-base text-stone-700">{{ subtitle }}</div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
})
</script>
